import Vue from 'vue';

Vue.component('modal', require('./Modal/Modal').default);
Vue.component('app-delete-modal', require('./Modal/DeleteModal').default);
Vue.component('app-form-group', require('./FormGroup').default);
Vue.component('app-form-group-selectable', require('./AppFromGroupSelectable').default);
Vue.component('app-page-top-section', require('./PageTopSection').default);
Vue.component('app-submit-button', require('./Button/SubmitButton').default);
Vue.component('app-default-button', require('./Button/DefaultButton').default);
Vue.component('modal', require('./Modal').default)